export default __webpack_public_path__ + "static/media/plane-alt.86dc1ade.svg";